export default function video() {
  var directive = {
    restrict: 'E',
    link: function(scope, element) {
      const video = element[0]
      const volume = angular.element('#volume')[0]

      function formatTime(timeInSeconds) {
        const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8)
      
        return {
          minutes: result.substr(3, 2),
          seconds: result.substr(6, 2)
        }
      }

      function initVideo() {
        const time = formatTime(Math.round(video.duration))
        scope.timeElapsed = `${time.minutes}:${time.seconds}`
        scope.$apply() // Must call this in order to bind updated model value to the view
      }
      
      function togglePlay() {
        if (video.paused || video.ended) {
          if (document.fullscreenEnabled) { // If fullscreen API supported
            document.documentElement.requestFullscreen() // Go fullscreen on play
          }
          video.play()
          scope.status = 'playing'
          scope.playOn = false
        } else {
          video.pause()
          scope.status = 'paused'
          scope.playOn = true
        }
      }

      function updateTimeElapsed() {
        const time = formatTime(Math.round(video.duration - video.currentTime))
        scope.timeElapsed = `${time.minutes}:${time.seconds}`
        scope.$apply()
      }

      function toggleMute() {
        video.muted = !video.muted

        if (video.muted) {
          volume.value = 0
          scope.volumeStatus = 'off'
        } else {
          volume.value = video.volume
          scope.volumeStatus = 'high'
        }
      }

      function updateVolume() {
        if (video.muted) {
          video.muted = false
        }
      
        video.volume = volume.value
      }

      function updateVolumeIcon() {
        if (video.muted || video.volume === 0) {
          scope.volumeStatus = 'off'
        } else if (video.volume > 0 && video.volume <= 0.5) {
          scope.volumeStatus = 'low'
        } else {
          scope.volumeStatus = 'high'
        }
      }

      function toggleCaptions() {
        for (var i = 0; i < video.textTracks.length; i++) {
          if (video.textTracks[i].mode === 'hidden') {
            video.textTracks[i].mode = 'showing'
          } else {
            video.textTracks[i].mode = 'hidden'
          }
        }
      }

      const time = formatTime(Math.round(0))
      scope.timeElapsed = `${time.minutes}:${time.seconds}`
      scope.status = 'paused'
      scope.volumeStatus = 'high'
      scope.volumeOn = true
      scope.timeOn = true
      scope.playOn = true
      for (var i = 0; i < video.textTracks.length; i++) {
        video.textTracks[i].mode = 'showing'
      }
      scope.controlsOn = true

      if (window.innerWidth <= 600) {
        scope.volumeOn = false
      }

      video.onloadedmetadata = () => initVideo()
      scope.togglePlay = () => togglePlay()
      video.ontimeupdate = () => updateTimeElapsed()
      scope.toggleMute = () => toggleMute()
      volume.oninput = () => updateVolume()
      video.onvolumechange = () => updateVolumeIcon()
      scope.toggleCaptions = () => toggleCaptions()
    }
  }

  return directive
}